import type { interfaces } from 'inversify';
import { iocNames } from '../iocNames';
import type { AuthStore } from '../stores/AuthStore';

export type IsUserAuthorized = () => boolean | undefined;

export const isUserAuthorized = (context: interfaces.Context) => () =>
  context.container.get<AuthStore>(iocNames.authStore).isUserAuthorized;
